import { FC, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import clsx from 'clsx';

import { reducerSidebar } from '../../../redux/reducer/user/reducers/reducerUser';
import { AppDispatch } from '../../../redux/reducer/store';

import SidebarLink from '../../custom/sidebarLink/sidebarLink';

import { ReactComponent as ReportsIcon } from '../../../assets/icons/reports-icon.svg';
import { ReactComponent as UnloadingsIcon } from '../../../assets/icons/unloading.svg';
import { ReactComponent as TunderIcon } from '../../../assets/icons/tunder-icon.svg';
import { ReactComponent as ChevronIcon } from '../../../assets/icons/chevron.svg';
import { ReactComponent as ListIcon } from '../../../assets/icons/list-icon.svg';
import { ReactComponent as LockIcon } from '../../../assets/icons/Lock.svg';
import { ReactComponent as ProjectsIcon } from '../../../assets/icons/projects.svg';
import { ReactComponent as VacancyIcon } from '../../../assets/icons/vacancy.svg';

interface IProps {
	isOpenUnloadings: boolean;
	isOpenSidebar: boolean;
}

const AdminSidebarSection: FC<IProps> = ({
	isOpenUnloadings,
	isOpenSidebar,
}) => {
	const dispatch = useDispatch<AppDispatch>();

	const pathname = window.location.pathname;
	const { claims } = useSelector((state: any) => state.user.user.data);
	const [additionalLinks, setAdditionalLinks] = useState<{ to: string; text: string }[]>([]);

	const handleOpenUnloadings = (event: any) => {
		event.preventDefault();

		localStorage.setItem('isOpenUnloadings', JSON.stringify(!isOpenUnloadings));

		dispatch(
			reducerSidebar({
				isOpenSidebar: isOpenSidebar,
				isOpenUnloadings: !isOpenUnloadings,
			})
		);
	};
	useEffect(() => {

		if (
			claims?.length > 0 &&
			(claims.includes('admin') || claims.includes('orders:excel'))
		) {
			setAdditionalLinks((prev) => [...prev, { to: '/unloadings/excel', text: 'Excel' }])
		}

		if (
			claims?.length > 0 &&
			(claims.includes('admin') || claims.includes('orders:zip'))
		) {
			setAdditionalLinks((prev) => [...prev, { to: '/unloadings/zip', text: 'Zip' }])
		}

		if (
			claims?.length > 0 &&
			(claims.includes('admin') || claims.includes('orders:payrolls'))
		) {
			setAdditionalLinks((prev: any) => [...prev, { to: '/unloadings/tables', text: 'Табели' }])
		}

		if (
			claims?.length > 0 &&
			(claims.includes('admin') || claims.includes('orders:cron'))
		) {
			setAdditionalLinks((prev) => [...prev, { to: '/unloadings/cron', text: 'Cron' }])
		}

		if (
			claims?.length > 0 &&
			(claims.includes('admin') || claims.includes('orders:import'))
		) {
			setAdditionalLinks((prev: any) => [...prev, { to: '/unloadings/tamplate', text: 'Загрузка шаблонов' }])
		}
	}, [claims]);

	return (
		<>
			<div className='menu__item'>
				<div className='buttons'>
					{claims &&
						claims?.length > 0 &&
						(claims.includes('admin') || claims.includes('reports:view') || claims.includes('reports:expired:view')) && (
							<SidebarLink
								icon={<ReportsIcon className='active__sidebar_icon' />}
								content='Отчеты'
								to='/reports'
							/>
						)}

					{claims &&
						claims?.length > 0 &&
						(claims.includes('admin') || claims.includes('orders:excel') || claims.includes('orders:zip') || claims.includes('orders:cron') || claims.includes('orders:payrolls')) && <SidebarLink
							chevron={
								<ChevronIcon
									className={clsx(
										'chevron__icon',
										isOpenUnloadings && 'active__chevron_icon',
										'active__sidebar_icon'
									)}
									onClick={handleOpenUnloadings}
								/>
							}
							icon={<UnloadingsIcon className='active__sidebar_icon' />}
							to={claims.includes('admin') || claims.includes('orders:excel') ? '/unloadings/excel' : additionalLinks[0]?.to}
							content='Выгрузки'
						/>}
					<div
						className={clsx(
							'additional__links_block',
							isOpenUnloadings && 'active__additional_links'
						)}
					>
						{isOpenSidebar && additionalLinks.map(link => (
							<span
								className={clsx(
									'additional__link',
									isOpenUnloadings && 'active__additional_link'
								)}
								key={link.to}
							>
								<Link
									className={clsx(
										'link',
										pathname.includes(link.to) && 'underline'
									)}
									to={link.to}
								>
									{link.text}
								</Link>
							</span>
						))}
					</div>

					{claims &&
						claims?.length > 0 &&
						(claims.includes('admin') || claims.includes('tander:view')) && (
							<SidebarLink
								icon={<TunderIcon className='active__sidebar_icon' />}
								to='/tunder/retail-outlets'
								content='Тандер'
							/>
						)}

					{claims &&
						claims?.length > 0 &&
						(claims.includes('admin') ||
							claims.includes('easy-merch:view')) && (
							<SidebarLink
								icon={<ListIcon className='active__sidebar_icon' />}
								to='/easymerch/outlets'
								content='Easy Merch'
							/>
						)}

					{claims &&
						claims?.length > 0 &&
						(claims.includes('admin') || claims.includes('customers:list') || claims.includes('role:claim:change')) && (
							<SidebarLink
								icon={<LockIcon className='active__sidebar_icon' />}
								to={
									claims.includes('admin') ||
										claims.includes('role:claim:change')
										? '/accessRights/roles'
										: claims.includes('customers:list')
											? '/accessRights/customers'
											: ''
								}
								content='Права доступа'
							/>
						)}

					{claims &&
						claims?.length > 0 &&
						(claims.includes('admin') || claims.includes('projects:list')) && (
							<SidebarLink
								icon={<ProjectsIcon className='active__sidebar_icon' />}
								to='/projects'
								content='Проекты'
							/>
						)}

					{claims?.length > 0 && (claims.includes('admin') || claims.includes('recruiting:vacancy:view') || claims.includes('recruiting:applicationform:view')) && (
						<SidebarLink
							icon={<VacancyIcon className='active__sidebar_icon' />}
							to={
								claims.includes('admin') ||
									claims.includes('recruiting:vacancy:view')
									? '/recruiting/vacancy'
									: claims.includes('recruiting:applicationform:view')
										? '/recruiting/applicationform'
										: ''
							}
							content='Набор персонала'
						/>
					)}
				</div>
			</div>
		</>
	);
};

export default AdminSidebarSection;
